namespace GeniuzPOS.AdvPromo {
    export enum PostStatus {
        UnPost = 0,
        Posted = 1
    }
    Serenity.Decorators.registerEnumType(PostStatus, 'GeniuzPOS.AdvPromo.PostStatus');
}
